import React from 'react'
import { defaultImage } from '@assets'
import { Scope } from "@utils";
import { Image, StyleSheet, TouchableOpacity, View } from 'react-native';
import { useNavigation, useTheme } from '@react-navigation/native';
import { Text, Icon } from '@components'
import { Theme } from '@theme';
import { useContactMappingStore } from '@store';
import { Contact } from '@hooks';
import { useLanguage } from '@context';

const AVATAR_SIZE = 40
const ITEM_HEIGHT = 50

export const ProfileItem = ({profile}: {profile: Contact}) => {
    const navigation = useNavigation()
    const theme = useTheme()
    const { t } = useLanguage()
    const styles = getStyle(theme)
    
    const {getScope} = useContactMappingStore()
    const scope = getScope(profile.id)
    const isGhost = scope.includes(Scope.GHOST)

    const goToProfile = () => {
        (navigation as any).navigate('Profile', {
            screen: 'DetailsGhostProfile',
            params: { profileId: profile.id }
          })
    }

    const addToContact = () => {

    }

    return(
        <TouchableOpacity
            style={styles.contactItem}
            onPress={goToProfile}
            activeOpacity={0.7}
        >
            <View style={styles.leftSection}>
                <Image
                    source={profile.avatarUrl ? { uri: profile.avatarUrl } : defaultImage}
                    style={styles.avatar}
                />
                
                {/* Icône ghost pour les contacts fantômes */}
                {isGhost && (
                    <View style={styles.ghostIndicator}>
                    <Icon 
                        name="ghost" 
                        size={14} 
                        color={theme.colors.white}
                    />
                    </View>
                )}
            </View>

            <View style={styles.middleSection}>
                <Text type="bodySmallBold" numberOfLines={1}>
                    {profile.fullName}
                </Text>
                <Text 
                    type="bodyExtraSmall" 
                    color={theme.colors.secondary}
                    numberOfLines={1}
                >
                    {profile.professions?.map(profession => profession.name).join(', ') || t('contactsScreen.professionNotSpecified')}
                </Text>
            </View>

            {/* Section droite avec icône message */}
            <View style={styles.rightSection}>
                <TouchableOpacity
                    style={styles.messageButton}
                    onPress={addToContact}
                    activeOpacity={0.7}
                >
                    <Icon 
                    name="userPlus" 
                    size={20} 
                    color={theme.colors.primary}
                    />
                </TouchableOpacity>
            </View>
        </TouchableOpacity>
    )
}


const getStyle = (theme: Theme) =>
    StyleSheet.create({
      container: {
        flexGrow: 1,
        paddingHorizontal: theme.spacing.lg,
        paddingTop: theme.spacing.md,
        paddingBottom: theme.spacing.xxl,
      },
      contactItem: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingVertical: theme.spacing.md,
        height: ITEM_HEIGHT
      },
      leftSection: {
        position: 'relative',
        marginRight: theme.spacing.md,
      },
      avatar: {
        width: AVATAR_SIZE,
        height: AVATAR_SIZE,
        borderRadius: AVATAR_SIZE / 2,
        backgroundColor: theme.colors.background,
      },
      ghostIndicator: {
        position: 'absolute',
        top: -3,
        right: -3,
        width: 20,
        height: 20,
        borderRadius: 10,
        backgroundColor: theme.colors.white,
        borderWidth: 1,
        borderColor: theme.colors.background,
        alignItems: 'center',
        justifyContent: 'center',
      },
      middleSection: {
        justifyContent: 'center',
      },
      hashtags: {
        marginTop: theme.spacing.xs / 2,
      },
      rightSection: {
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: theme.spacing.md,
      },
      messageButton: {
        padding: theme.spacing.sm,
      },
      emptyState: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: theme.spacing.xxl,
      },
      separator: {
        height: 1,
        backgroundColor: theme.colors.grey,
        marginLeft: AVATAR_SIZE + theme.spacing.md,
      },
}) 